<template>
    <div >
        <section id="hero_info">
            <article>
                <p class="caption">PDF다운로드</p>
            </article>
            <div class="attention-logged-in">
                <el-button id="pdf-eprint-edit"
                           type="success"
                           class="button-block"
                           @click="openDownload()">
                    <i class="el-icon-printer"></i> 다운로드
                </el-button>
                <p class="addition" >※자동으로 다운로드가 되지 않을 경우 상단의「다운로드」버튼을 클릭해 주세요.</p>
            </div>
        </section>
    </div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {
    data: function () {
        return {}
    },
    created : function(){
        console.log('created')
        const urlParams = new URLSearchParams(window.location.search);
        var blob = urlParams.get("blob")
        var filename = urlParams.get("filename")
        let link = document.createElement('a')
        link.href = blob
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },
    computed: {},
    methods: {
        openDownload: function () {
            const urlParams = new URLSearchParams(window.location.search);
            var blob = urlParams.get("blob")
            var filename = urlParams.get("filename")
            let link = document.createElement('a')
            link.href = blob
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
    },
    watch: {},
    mounted: function () {}
}
</script>
